export enum Commodities {
  'cattle' = 'cattle',
  'cocoa' = 'cocoa',
  'coffee' = 'coffee',
  'oilPalm' = 'oil palm',
  'rubber' = 'rubber',
  'soya' = 'soya',
  'timber' = 'timber',
}
